import * as React from 'react';

const ZoTexel = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={40} height={40} fill="none" viewBox="0 0 40 40" {...props}>
        <path fill="#3E71A9" d="M0 4a4 4 0 0 1 4-4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M32.857 5H7.143C5.959 5 5 5.96 5 7.143v25.714C5 34.041 5.96 35 7.143 35h25.714C34.041 35 35 34.04 35 32.857V7.143C35 5.959 34.04 5 32.857 5"
        />
        <path
            fill="#fff"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.142 33.286a.429.429 0 1 0 0-.857.429.429 0 0 0 0 .857M7.142 7.572a.429.429 0 1 0 0-.858.429.429 0 0 0 0 .857M32.857 7.572a.429.429 0 1 0 0-.858.429.429 0 0 0 0 .857M32.857 33.286a.429.429 0 1 0 0-.857.429.429 0 0 0 0 .857"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M26 19a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
        />
        <path
            fill="#fff"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.538 8.964c.741 0 1.123.87.651 1.415l-.045.049-6.68 6.68h6.931v1.713h-9c-.741 0-1.123-.87-.651-1.414l.045-.049 6.679-6.68H8.752V8.965zM18.395 21.607v1.714h-5.143v5.357c0 .648.308 1.038.793 1.07l.064.002h4.286v1.714h-4.286c-1.504 0-2.525-1.167-2.57-2.682l-.001-.104v-5.357H8.752v-1.714zM22.798 21.607l2.117 4.071H27.4l2.117-4.071h1.932l-2.562 4.929 2.562 4.928h-1.932L27.4 27.392h-2.485l-2.117 4.072h-1.932l2.563-4.928-2.563-4.93z"
        />
    </svg>
);
export default ZoTexel;
